import { useContext, useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";

import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import AccordionClassGeral from "./children/AccordionTipoGeral";
import AccordionClassTributacao from "./children/AccordionTipoTributacao";
import useTipoServicoController from "./controllers/TipoServicoController";
import { Line } from "./styles/TipoServico";
import { TipoServicoContext } from "./contexts/TipoServicoContext";
import { useHistory } from "react-router-dom";
import { findEstadoById } from "../../../repository/ERP/prouser/EstadoService";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { useQuery } from "react-query";
import { notify } from "../../../utils/notify";
import { GlobalVariables } from "../../../GlobalVariables";

const TipoServicoCadastro = ({ location }) => {
  const { handleSubmit, clearClassRegister, handleSetData } =
    useTipoServicoController();

  const { loading } = useContext(TipoServicoContext);
  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const [where, setWhere] = useState({ uf: "SP", tipo: "2" });

  const { isLoading: isUfCompanyLoading } = useQuery(
    "uf-empresa-logada",
    () => findEstadoById(queryParams.empresa_cnpj, queryParams.id_estado),
    {
      onSuccess: (response) => {
        if (!response?.success) {
          return notify(response.message, true, "error");
        }

        const ufData = response?.data?.estado || "SP";
        setWhere({ uf: ufData, tipo: "2" });
      },
    }
  );

  const back = () => {
    clearClassRegister();
    push("listagem");
  };

  useEffect(() => {
    handleSetData(location?.state?.id);
  }, [location?.state?.id, handleSetData]);

  return (
    <>
      <Loading open={loading || isUfCompanyLoading} />
      <HeaderModule
        title="CADASTRO DE TIPOS DE SERVIÇOS"
        videoId={GlobalVariables.screenVideosIds.cadastroTiposServicos}
      />
      <Margin top="100">
        <Container maxWidth="xl">
          <AccordionClassGeral where={where} />
          <AccordionClassTributacao />
          <Line container />
          <Line container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Btn
                label="Voltar"
                hovercolor="darkred"
                bgcolor="tertiary"
                onClick={back}
              />
            </Grid>
            <Grid item>
              <Btn label="Salvar" onClick={() => handleSubmit(false)} />
            </Grid>
            <Grid item>
              <Btn label="Salvar e Novo" onClick={() => handleSubmit(true)} />
            </Grid>
          </Line>
        </Container>
      </Margin>
    </>
  );
};

export default TipoServicoCadastro;
